'use strict';

var React = require('react'),
    classnames = require('classnames'),
    connect = require('react-redux').connect,
    dialogsActions = require('../actions/dialogsActions'),
    flashError = dialogsActions.flashError,
    isEmail = require('validator/lib/isEmail'),
    validatePassword = require('../../lib/validations').validatePassword,
    reportAdwordsConversion = require('../utils').reportAdwordsConversion;

var SignupFormInput = React.createClass({
	displayName: 'SignupFormInput',

	propTypes: {
		autoFocus: React.PropTypes.bool.isRequired,
		id: React.PropTypes.string.isRequired,
		label: React.PropTypes.string.isRequired,
		name: React.PropTypes.string.isRequired,
		onChange: React.PropTypes.func.isRequired,
		placeholder: React.PropTypes.string,
		type: React.PropTypes.string.isRequired,
		validation: React.PropTypes.string,
		value: React.PropTypes.string
	},

	getDefaultProps: function getDefaultProps() {
		return {
			autoFocus: false
		};
	},

	render: function render() {
		var className = classnames({
			'form-group': true,
			'has-error': this.props.validation
		});

		return React.createElement(
			'div',
			{ className: className },
			React.createElement(
				'label',
				{ htmlFor: this.props.id },
				this.props.label,
				':'
			),
			React.createElement('input', {
				autoFocus: this.props.autoFocus,
				type: this.props.type,
				className: 'form-control',
				id: this.props.id,
				placeholder: this.props.placeholder,
				name: this.props.name,
				value: this.props.value,
				onChange: this.props.onChange
			}),
			this.props.validation ? React.createElement(
				'span',
				{ className: 'help-block' },
				this.props.validation
			) : null
		);
	}
});

var SignupForm = React.createClass({
	displayName: 'SignupForm',

	propTypes: {
		dispatch: React.PropTypes.func.isRequired
	},

	getInitialState: function getInitialState() {
		return {
			email: '',
			password: '',
			submitted: false
		};
	},

	render: function render() {
		// Only show errors after submitting
		var validations = this.state.submitted ? this.getValidations() : {};

		return React.createElement(
			'form',
			{ id: 'signup-form-form', noValidate: true, onSubmit: this.checkValidations, action: '/signup', method: 'post' },
			React.createElement(SignupFormInput, {
				autoFocus: true,
				label: 'Email',
				type: 'email',
				id: 'emailInput',
				placeholder: 'Email',
				name: 'username',
				value: this.state.email,
				onChange: this.updateState.bind(this, 'email'),
				validation: validations.email
			}),
			React.createElement(SignupFormInput, {
				label: 'Password',
				type: 'password',
				id: 'passwordInput',
				placeholder: 'Password',
				name: 'password',
				value: this.state.password,
				onChange: this.updateState.bind(this, 'password'),
				validation: validations.password
			}),
			React.createElement(
				'div',
				{ className: 'form-group' },
				React.createElement('input', { type: 'submit', className: 'g-recaptcha btn btn-primary btn-block',
					'data-sitekey': '6Les3n0qAAAAAKs2ON3c3uPAxwmwAh6WC4kWew77',
					'data-callback': 'onSubmit',
					'data-action': 'submit',
					value: 'Create an account' })
			)
		);
	},

	getValidations: function getValidations() {
		var validations = {};

		if (!isEmail(this.state.email)) {
			validations.email = 'Please enter a valid email';
		}

		validations.password = validatePassword(this.state.password);

		return validations;
	},

	checkValidations: function checkValidations(e) {
		this.setState({ submitted: true });

		var validations = this.getValidations();
		var isValid = Object.keys(validations).every(function (attr) {
			return !validations[attr];
		});

		if (!isValid) {
			e.preventDefault();
			this.props.dispatch(flashError('Please fix errors to create an account'));
			return;
		}

		// Pass all validations, report to Google as a conversion
		reportAdwordsConversion();
	},

	updateState: function updateState(attr, e) {
		var newState = {};
		newState[attr] = e.target.value;
		this.setState(newState);
	}
});

module.exports = Object.assign(connect()(SignupForm), {
	Component: SignupForm
});


//////////////////
// WEBPACK FOOTER
// ./client/components/SignupForm.js
// module id = 436
// module chunks = 0